<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="third-share">
        <h1 class="third-share__title">
            第三方信息共享清单-启蒙好课
        </h1>

        <p class="third-share__intro">
            当您使用第三方提供的服务时，我们会在获得或确保第三方获得您的授权同意后，以及其他符合法律法规规定的情形下共享对应信息。
        </p>
        <p class="third-share__intro">
            为保障毛豆系列应用产品的稳定运行或实现相关功能，我们接入了由第三方提供的软件开发包（SDK）来实现相关目的。我们对接入的相关第三方SDK均在下清单中罗列，您可以通过具体的隐私政策链接查看第三方的个人信息处理规则。
        </p>

        <div
            v-for="(cat, catIndex) in categories"
            :key="catIndex"
            class="third-share__category"
        >
            <h2 class="third-share__cat-title">
                {{cat.title}}
            </h2>

            <section
                v-for="(row, sdkIndex) in cat.sdks"
                :key="sdkIndex"
                class="third-share__card"
            >
                <h3 class="third-share__sdk-name">
                    {{row.sdkName}}
                </h3>
                <dl class="third-share__dl">
                    <div class="third-share__row">
                        <dt>第三方名称</dt>
                        <dd>{{row.company}}</dd>
                    </div>
                    <div class="third-share__row">
                        <dt>使用场景</dt>
                        <dd>{{row.scenario}}</dd>
                    </div>
                    <div class="third-share__row">
                        <dt>使用目的</dt>
                        <dd>{{row.purpose}}</dd>
                    </div>
                    <div class="third-share__row">
                        <dt>共享的信息</dt>
                        <dd>{{row.dataTypes}}</dd>
                    </div>
                    <div class="third-share__row">
                        <dt>共享方式</dt>
                        <dd>{{row.shareMethod}}</dd>
                    </div>
                    <div class="third-share__row">
                        <dt>第三方个人信息处理规则</dt>
                        <dd>
                            <template v-if="row.policyUrls.length === 1">
                                <a
                                    class="third-share__link"
                                    :href="row.policyUrls[0].url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{{row.policyUrls[0].url}}</a>
                            </template>
                            <template v-else>
                                <div
                                    v-for="(p, i) in row.policyUrls"
                                    :key="i"
                                    class="third-share__policy-item"
                                >
                                    {{p.label}}：
                                    <a
                                        class="third-share__link"
                                        :href="p.url"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{{p.url}}</a>
                                </div>
                            </template>
                        </dd>
                    </div>
                </dl>
            </section>
        </div>
    </div>
</template>

<script>

/* eslint-disable max-len */

/**
 * 字段与《个人信息保护政策》第三方 SDK 目录及隐私政策摘要中的披露保持一致性。
 * 分类组织：「支付与一键登录」「教学互动与音视频」「数据统计、防风控与广告归属」
 *           「消息推送服务」「地图定位与其他服务」
 */
const CATEGORIES = [
    {
        title: '1. 支付与一键登录服务',
        sdks: [
            {
                sdkName: '微信开放SDK (OpenSDK)',
                company: '财付通支付科技有限公司 / 腾讯科技（深圳）有限公司',
                scenario: '在购买课程使用微信支付、或使用微信授权登录、分享时',
                purpose: '支持微信授权登录、微信分享和微信支付',
                dataTypes: '用户主动选择的图片/内容、微信头像、昵称信息、第三方应用生成的支付订单标识、传输支付状态（成功/失败），'
                    + '以及设备版本、系统版本、生成ID、手机样式、手机名、BSSID、SSID等设备信息',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8', label: ''}],
            },
            {
                sdkName: 'Alipay（支付宝）SDK',
                company: '支付宝（中国）网络技术有限公司',
                scenario: '在应用内使用支付宝支付时',
                purpose: '帮助用户在应用内使用支付宝支付，并提高支付环境的安全性',
                dataTypes: '设备识别信息（如IMEI、Android ID、IMSI、ICCID、OAID、MAC地址）、地理位置信息、运行中进程信息、WiFi信息、传感器列表、BSSID、SSID、IP地址',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://opendocs.alipay.com/common/02kiq3', label: ''}],
            },
            {
                sdkName: '闪验、创蓝云智 SDK (包含天翼认证等)',
                company: '上海创蓝云智信息科技有限公司',
                scenario: '用户在手机端进行一键登录时',
                purpose: '实现手机号码网关取号、一键免密登录及反欺诈',
                dataTypes: 'IP地址、网卡（MAC地址）、国际移动设备识别码（IMEI）、OAID（替代IMEI）、SIM卡信息、手机机型、系统类型、系统版本、网络环境、'
                    + '网关取号报错日志、已安装App信息、运行中进程信息、Android ID、软件安装列表、运营商信息、ICCID、IMSI；iOS端收集IDFV和IP地址',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://doc.chuanglan.com/document/T98GE1KYCZDMJDHN', label: ''}],
            },
            {
                sdkName: '联通/移动/电信登录 SDK',
                company: '中国联合网络通信有限公司 / 中国移动通信集团有限公司 / 中国电信集团有限公司',
                scenario: '识别用户手机号码进行一键登录/号码校验时',
                purpose: '提供一键登录与号码认证服务',
                dataTypes: '网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商、IP地址',
                shareMethod: 'SDK自行采集',
                policyUrls: [
                    {url: 'https://msv6.wosms.cn/html/oauth/privacy-policy.html', label: '联通登录'},
                    {url: 'https://rzzm.h5cmpassport.com/mall-oms-ui/protocol/index.html', label: '移动登录'},
                    {url: 'https://id.189.cn/html/agreement_709.html', label: '电信登录'},
                ],
            },
        ],
    },
    {
        title: '2. 教学互动与音视频服务',
        sdks: [
            {
                sdkName: '讯飞 SDK',
                company: '安徽科大讯飞信息科技股份有限公司',
                scenario: '用户进行语音评测环节时',
                purpose: '用于进行语音评测与交互',
                dataTypes: '设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID、中国移动UAID（仅限安卓）、OAID（仅限安卓）、UUID（仅限iOS）、MAC地址（仅限Linux）',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://www.xfyun.cn/doc/total_sdk_privacy/ise_privacy.html', label: ''}],
            },
            {
                sdkName: '阿里云播放器/OSS SDK',
                company: '阿里云计算有限公司',
                scenario: '用户观看教学视频及保存/上传个人朗诵作品时',
                purpose: '实现视频播放功能、保存用户上传的作品资源',
                dataTypes: '操作系统API版本、CPU信息、IDFV、运营商信息、设备品牌、设备型号、操作系统、系统时区、应用版本、应用发布渠道',
                shareMethod: 'SDK本机采集',
                policyUrls: [
                    {url: 'https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html', label: '播放器服务'},
                    {url: 'https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html', label: '安卓端存储'},
                    {url: 'http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.0.0.3fc85ff28enogr', label: 'iOS端存储'},
                ],
            },
            {
                sdkName: 'Byted Effect SDK',
                company: '北京火山引擎科技有限公司',
                scenario: '录制视频作品或合成朗诵作品时',
                purpose: '录制视频，帮助用户进行图像处理与作品合成',
                dataTypes: '不收集个人信息，仅在端侧进行图像/视频流处理',
                shareMethod: '无',
                policyUrls: [{url: 'https://www.volcengine.com/docs/6256/64902', label: ''}],
            },
        ],
    },
    {
        title: '3. 数据统计、防风控与广告归属',
        sdks: [
            {
                sdkName: '增长营销套件SDK（com.bytedance.bdtracker、com.bytedance.applog）',
                company: '北京火山引擎科技有限公司',
                scenario: '用户在应用内浏览及操作时',
                purpose: '进行用户行为统计分析，以优化产品体验',
                dataTypes: '设备型号、操作系统、MAC地址、Android ID、OAID、唯一设备标识符（包括IMEI）、用户行为数据',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://www.volcengine.com/docs/84129/1261812?lang=zh', label: ''}],
            },
            {
                sdkName: 'GrowingIO SDK',
                company: '北京双鑫汇科技有限公司（GrowingIO）',
                scenario: '用户在应用内浏览及操作时',
                purpose: '上报埋点日志进行数据分析，从而改进我们的产品和服务',
                dataTypes: '操作系统、设备型号、系统版本、Android ID、IMEI、MAC地址、OAID、用户在App内的浏览与点击行为数据、运行中进程信息、粘贴板信息、软件安装列表',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://accounts.growingio.com/privacy', label: ''}],
            },
            {
                sdkName: '友盟移动统计/崩溃采集 SDK',
                company: '友盟同欣（北京）科技有限公司',
                scenario: 'App发生异常闪退或日常数据统计时',
                purpose: '进行App数据统计分析与崩溃信息收集',
                dataTypes: '设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID；可选收集IMEI/IMSI/ICCID）、网络信息、'
                    + '位置信息（可选）、应用列表（可选）、客户端运行日志',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://www.umeng.com/page/policy', label: ''}],
            },
            {
                sdkName: '数字联盟可信ID SDK',
                company: '北京数字联盟网络科技有限公司',
                scenario: '应用启动及日常运行中进行安全风控时',
                purpose: '安全风控，预防恶意刷量与作弊行为',
                dataTypes: '设备基本情况（制造商、型号、状态、系统版本、应用版本）、传感器信息（光、磁场、重力、压力、方向、旋转矢量、陀螺仪、加速度等）、'
                    + '应用信息、通信状态、信号强度、蓝牙信息、设备网络状态【网络接入形式、IP地址、WIFI信息（BSSID、SSID）、运营商类型及网络基站信息】、设备物理环境信息',
                shareMethod: '本机采集',
                policyUrls: [{url: 'https://www.shuzilm.cn/privacy.html', label: ''}],
            },
            {
                sdkName: '巨量引擎转化 SDK',
                company: '北京巨量引擎网络技术有限公司',
                scenario: '广告投放激活及数据监测时',
                purpose: '广告投放归因及数据监测、上报',
                dataTypes: '设备标识符（IMEI/AndroidID/MAC/OAID/IDFV/IDFA/硬件序列号/IMSI/MEID)、设备信息（手机型号/手机厂商/系统版本）、位置信息、IP地址、设备传感器数据、运营商信息',
                shareMethod: '本机采集，接口上报',
                policyUrls: [{url: 'https://open.oceanengine.com/labels/8/docs/1708428054592516', label: ''}],
            },
            {
                sdkName: '腾讯Bugly专业版SDK',
                company: '深圳市腾讯计算机系统有限公司',
                scenario: '排查质量问题，帮助APP提升运行质量',
                purpose: 'BuglySDK基于为第三方提供APP崩溃分析及更新能力的目的,收集和使用个人信息(帮助开发者实现崩溃监控、异常分析、ANR排查、Crash率统计等功能，提升App稳定性)',
                dataTypes: '手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID',
                shareMethod: 'SDK本机采集，加密上报服务端',
                policyUrls: [{url: 'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56', label: ''}],
            },
        ],
    },
    {
        title: '4. 消息推送服务',
        sdks: [
            {
                sdkName: '腾讯移动推送 TPNS SDK',
                company: '腾讯云计算（北京）有限责任公司',
                scenario: '向用户客户端推送课程提醒或公告消息时',
                purpose: '实现消息精准推送',
                dataTypes: '厂商、机型、通知栏开关状态、网络状态、系统语言、时区、设备分辨率、设备名称、国家编码、设备标识信息（Android ID、MAC地址、IDFV、APNs Device Token）、软件安装列表、Crash堆栈信息',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b', label: ''}],
            },
            {
                sdkName: '手机厂商推送 SDK',
                company: '华为软件技术有限公司、小米科技有限责任公司、广东欢太科技有限公司、维沃移动通信有限公司、珠海市魅族科技有限公司、荣耀终端有限公司等',
                scenario: '在对应品牌手机终端推送消息时',
                purpose: '保障消息在各主流品牌手机上的送达率',
                dataTypes: '应用基本信息、应用内设备标识符（如AAID、Push Token、RegId）、设备硬件信息（设备型号、制造商、屏幕显示、设备激活时间）、系统基本信息及设置（系统版本、网络类型、运营商归属地、语言设置）、软件安装列表等',
                shareMethod: 'SDK本机采集',
                policyUrls: [
                    {url: 'https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177', label: '华为推送'},
                    {url: 'https://privacy.mi.com/all/zh_CN/', label: '小米推送'},
                    {url: 'https://open.oppomobile.com/new/developmentDoc/info?id=10288', label: 'OPPO推送'},
                    {url: 'https://dev.vivo.com.cn/documentCenter/doc/878', label: 'vivo推送'},
                    {url: 'https://open.flyme.cn/docs?id=202', label: '魅族推送'},
                    {url: 'https://developer.honor.com/cn/docs/11002/guides/sdk-data-security', label: '荣耀推送'},
                ],
            },
        ],
    },
    {
        title: '5. 地图定位与其他服务',
        sdks: [
            {
                sdkName: '高德定位 SDK',
                company: '高德软件有限公司',
                scenario: '用户在选择地区或添加收货地址时',
                purpose: '获取地理位置，以提供更好、更准确的地域性课程展示',
                dataTypes: '设备识别信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC地址、OAID、IMSI、ICCID）、地理位置信息、WIFI信息、BSSID、SSID、加速度传感器、压力传感器、旋转矢量传感器、传感器列表、硬件序列号',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://lbs.amap.com/home/privacy/', label: ''}],
            },
            {
                sdkName: '听云 SDK',
                company: '北京基调网络股份有限公司',
                scenario: 'App日常运行及发生崩溃时',
                purpose: '收集使用崩溃信息以进行统计分析、性能优化',
                dataTypes: '唯一设备识别码（Android OAID）、设备识别信息、客户端运行日志',
                shareMethod: 'SDK本机采集',
                policyUrls: [{url: 'https://www.tingyun.com/legal-declaration', label: ''}],
            },
            {
                sdkName: '欢支付',
                company: '广州欢网科技有限责任公司',
                scenario: '进行大屏支付或相关渠道支付时',
                purpose: '大屏支付支持与统计',
                dataTypes: 'IP地址和设备MAC地址（共享信息为统计级、匿名化数据，无法识别到特定个人）',
                shareMethod: '本机采集，接口传输',
                policyUrls: [{url: 'https://ottepg-moss.cedock.com/paysdk/payagreement.html', label: ''}],
            },
        ],
    },
];

export default {
    name: 'PolicyThirdShare',
    components: {
    },
    data() {
        return {
            categories: CATEGORIES,
        };
    },
    mounted() {
        document.title = '第三方信息共享清单';
    },
};
</script>

<style scoped>
/*
 * 与 policysummary 一致：全站 rem 随宽度变化，本页用 px 保证横屏可读。
 */
.third-share {
    box-sizing: border-box;
    max-width: 672px;
    margin: 0 auto;
    padding: 12px 14px 24px;
    font-size: 13px;
    line-height: 1.55;
    color: #333;
    text-align: left;
    -webkit-font-smoothing: antialiased;
}

.third-share__title {
    margin: 0 0 14px;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
    line-height: 1.35;
    color: #1a1a1a;
}

.third-share__intro {
    margin: 0 0 10px;
    text-indent: 2em;
}

.third-share__intro:last-of-type {
    margin-bottom: 16px;
}

.third-share__category {
    margin-bottom: 20px;
}

.third-share__category:last-child {
    margin-bottom: 0;
}

.third-share__cat-title {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
}

.third-share__card {
    margin-bottom: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eee;
}

.third-share__card:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.third-share__sdk-name {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
}

.third-share__dl {
    margin: 0;
}

.third-share__row {
    margin-bottom: 7px;
}

.third-share__row:last-child {
    margin-bottom: 0;
}

.third-share__row dt {
    margin: 0 0 2px;
    font-size: 12px;
    font-weight: 600;
    color: #555;
}

.third-share__row dd {
    margin: 0;
    font-size: 13px;
    color: #333;
    word-break: break-word;
}

.third-share__policy-item {
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 1.45;
}

.third-share__policy-item:last-child {
    margin-bottom: 0;
}

.third-share__link {
    color: #3370ff;
    text-decoration: none;
    word-break: break-all;
}

.third-share__link:hover {
    text-decoration: underline;
}

@media (orientation: landscape) and (max-height: 520px) {
    .third-share {
        padding: 8px 12px 16px;
        font-size: 12px;
        line-height: 1.5;
    }

    .third-share__title {
        margin-bottom: 8px;
        font-size: 15px;
    }

    .third-share__cat-title {
        font-size: 13px;
    }

    .third-share__sdk-name {
        font-size: 13px;
    }

    .third-share__row dt {
        font-size: 11px;
    }

    .third-share__row dd {
        font-size: 12px;
    }

    .third-share__policy-item {
        font-size: 11px;
    }
}
</style>
